import { IconClose16 } from '@cian/ui-kit/icons';
import cn from 'classnames';
import * as React from 'react';

import { DrawButtonNew } from './DrawButtonIcon';
import { ICON_SIZE_MODIFIER_TO_CLASS } from './constants';
import * as styles from './styles.css';
import { IDrawButtonProps } from './types';
import { ControlButton } from '../../../../../common/components/ControlButton';

export const DrawButton: React.FC<IDrawButtonProps> = React.forwardRef(
  (
    { active, hasPolygons, iconSizeModifier = 'M', onActivateClick, onCancelClick, ...sharedProps },
    ref: React.Ref<HTMLButtonElement>,
  ) => {
    const className = ICON_SIZE_MODIFIER_TO_CLASS[iconSizeModifier];

    const handleClick = React.useCallback(() => {
      if (hasPolygons) {
        onCancelClick();
      } else {
        onActivateClick();
      }
    }, [hasPolygons, onActivateClick, onCancelClick]);

    return (
      <ControlButton
        {...sharedProps}
        data-name="DrawButton"
        ref={ref}
        active={active}
        className={cn(className, styles['extra-bottom-margin'])}
        size="M"
        tooltip="Выделение области"
        onClick={handleClick}
      >
        {hasPolygons ? (
          <IconClose16 color={active ? 'white_100' : 'primary_100'} />
        ) : (
          <DrawButtonNew active={Boolean(active)} />
        )}
      </ControlButton>
    );
  },
);

DrawButton.displayName = 'DrawButton';
